// General
import lodash from 'lodash';
import jquery from 'jquery';
window.$ = window.jQuery = jquery;
// import bootstrap from 'bootstrap';
import cropper from 'cropperjs';
import phoneformat from 'phoneformat';
import moment from 'moment';
import range from './utilities/range.js'
window.range = range;

// Angular
import angular from 'angular';
import angularmaterial from 'angular-material';
import angularanimate from 'angular-animate';
import angularroute from 'angular-route';
import angularbootstrap from 'angular-ui-bootstrap';
import '../../node_modules/isteven-angular-multiselect/isteven-multi-select';
import 'angular-hotkeys';
import angularsanitize from 'angular-sanitize';
import 'ng-toast';
import 'angular-upload';
import angularfileupload from 'ng-file-upload';
import angularchartjs from 'angular-chart.js';
import './utilities/counter/angular-count-to.min.js';
// import './utilities/datetime/bootstrap-material-datetimepicker';
import angularDragula from 'angularjs-dragula';
import ngMaterialDatePicker from 'ng-material-datetimepicker';

window.angularApp = angular.module('TetherApp', [
    angularroute,
    angularbootstrap,
    'isteven-multi-select',
    angularmaterial,
    'cfp.hotkeys',
    angularanimate,
    angularsanitize,
    'ngToast',
    'lr.upload',
    angularfileupload,
    angularchartjs,
    'countTo',
    angularDragula(angular),
    ngMaterialDatePicker
]);

angular.module('TetherApp').run(['$http', function($http) {
    let token = document.head.querySelector('meta[name="csrf-token"]');
    if (token) {
        $http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        $http.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
        $http.defaults.headers.common['X-PARENT-REQUEST-PATH'] = window.location.pathname;
    }
}]);

// Standardized date format constant.
angular.module('TetherApp').constant('DATE_FORMAT', 'd/M/yy h:mm a');

// Phone number formatter to prevent browsers/clients from hyperlinking them.
angular.module('TetherApp').filter('tel', ['$sce', function ($sce) {
    return function (phoneNumber) {
        if (!phoneNumber) {
            return phoneNumber;
        }

        return $sce.trustAsHtml(
            phoneNumber.replace(/(1)?(\d{3})(\d{3})(\d{4})/, "<span>$1</span> <span>$2-</span><span>$3</span><span>-$4</span>")
        );
    }
}]);

angular.module('TetherApp').config(['$mdThemingProvider', function($mdThemingProvider) {
    $mdThemingProvider.definePalette('amazingPaletteName', {
        '50': '000000',
        '100': '000000',
        '200': '000000',
        '300': '000000',
        '400': '000000',
        '500': '000000',
        '600': '000000',
        '700': '000000',
        '800': '000000',
        '900': '000000',
        'A100': '000000',
        'A200': '000000',
        'A400': '000000',
        'A700': '000000',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'],
        'contrastLightColors': undefined
    });

    $mdThemingProvider.theme('default').accentPalette('amazingPaletteName');
}]);

angular.module('TetherApp').filter('capitalize', [function () {
    return function (input) {
        return (!input) ? '' : input.charAt(0).toUpperCase() + input.substr(1).toLowerCase();
    }
}]);

angular.module('TetherApp').filter('capitalizeWords', [function () {
    return function (input) {
        return (!input) ? '' : input.replace(/\-/g, ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }
}]);

angular.module('TetherApp').filter('snakeToPascal', [function () {
    return function (input) {
        let testString = input;
        if (testString != undefined) {
            testString = testString.charAt(0).toUpperCase() + input.substr(1);
            while (testString.indexOf("_") > -1) {
                let index = testString.indexOf("_");
                testString = testString.replace("_", " ");
                if (index > 0) {
                    testString = testString.substr(0, index + 1) + testString.charAt(index + 1).toUpperCase() + testString.substr(index + 2);
                }
            }
            return testString;
        }
    }
}]);

angular.module('TetherApp').factory('authInterceptorService', ['$q','$location', function ($q, $location) {
    let redirectLocation = $location.protocol()+'://'+$location.host()+'/auth/logout';
    let redirectNoClient = $location.protocol()+'://'+$location.host()+'/';

    if ($location.port() !== 80) {
        redirectLocation = $location.protocol()+'://'+$location.host()+':'+$location.port()+'/auth/logout';
        redirectNoClient = $location.protocol()+'://'+$location.host()+':'+$location.port()+'/';
    }

    let responseError = function (rejection) {
        if (rejection.hasOwnProperty('data')
            && rejection.data != null
            && rejection.data != undefined
            && typeof rejection.data === 'string'
            && rejection.data.indexOf('TokenMismatchException') > -1) {
            window.location.href = redirectLocation;
        }

        if (rejection.hasOwnProperty('data')
            && rejection.data != null
            && rejection.data != undefined
            && rejection.data.hasOwnProperty('error')
            && rejection.data.error.hasOwnProperty('code')
            && rejection.data.error.code === 1) {
            window.location.href = redirectNoClient;
        }

        return $q.reject(rejection);
    };

    let response = function(response) {
        //If a request to an api end point
        // is successfully redirected to the login page,
        // redirect parent container
        if (response.hasOwnProperty('data')
            && response.data != null
            && response.data != undefined
            && response.hasOwnProperty('config')
            && response.config.hasOwnProperty('url')
            && response.config.url.indexOf('api/v1') > -1
            && typeof response.data === 'string'
            && response.data.indexOf('login') > -1
            && response.data.indexOf('email') > -1
            && response.data.indexOf('password') > -1) {
            window.location.href = redirectLocation;
        } else {
            return response;
        }
    };

    return {
        responseError: responseError,
        response: response
    };
}]);

angular.module('TetherApp').config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('authInterceptorService');
}]);

// START: HELPER METHODS
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}
// END: HELPER METHODS
